var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { call, put, takeLatest, select, } from 'redux-saga/effects';
import dayjs from 'dayjs';
import { collectUnavailableDates, formatDateForDateRequest, } from '../../../helpers/time';
import { ActionTypes as SelectedStoreActionTypes } from '../../location/selectedStore';
import { runActionAfterDelay } from '../../utils/sagas';
import { getSelectedStoreId } from '../../location/selectedStore/selectors';
import { ActionTypes, actions } from './actions';
import { fetchUnavailableDates } from './requests';
import { getSelectedDateValue } from './selectors';
export function loadDateAvailability(_a) {
    var selectedMonth, selectedStoreServiceId, selectedStoreId, selectedDateValue, data, today_1, unavailableDates, todayDateItem, error_1;
    var payload = _a.payload;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 8, , 10]);
                selectedMonth = payload.selectedMonth, selectedStoreServiceId = payload.selectedStoreServiceId;
                return [4 /*yield*/, select(getSelectedStoreId)];
            case 1:
                selectedStoreId = _b.sent();
                return [4 /*yield*/, select(getSelectedDateValue)];
            case 2:
                selectedDateValue = _b.sent();
                return [4 /*yield*/, call(fetchUnavailableDates, selectedStoreId, selectedStoreServiceId, formatDateForDateRequest(selectedMonth))];
            case 3:
                data = _b.sent();
                today_1 = dayjs().format('YYYY-MM-DD');
                unavailableDates = collectUnavailableDates(data);
                return [4 /*yield*/, put(actions.markDatesUnavailable(unavailableDates))];
            case 4:
                _b.sent();
                if (!(!unavailableDates.includes(today_1) && !selectedDateValue)) return [3 /*break*/, 6];
                todayDateItem = data.find(function (item) { return item.date === today_1; });
                return [4 /*yield*/, put(actions.selectDateAvailabilityItem(todayDateItem))];
            case 5:
                _b.sent();
                _b.label = 6;
            case 6: return [4 /*yield*/, put(actions.loadDateAvailabilitySuccess(data))];
            case 7:
                _b.sent();
                return [3 /*break*/, 10];
            case 8:
                error_1 = _b.sent();
                return [4 /*yield*/, put(actions.loadDateAvailabilityFailure(error_1))];
            case 9:
                _b.sent();
                return [3 /*break*/, 10];
            case 10: return [2 /*return*/];
        }
    });
}
export function resetDateAvailability() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, put(actions.resetDateAvailability())];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
export function sagas() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, takeLatest(ActionTypes.LOAD_DATE_AVAILABILITY, loadDateAvailability)];
            case 1:
                _a.sent();
                return [4 /*yield*/, takeLatest(SelectedStoreActionTypes.LOAD_SERVICE_ID, resetDateAvailability)];
            case 2:
                _a.sent();
                return [4 /*yield*/, takeLatest(ActionTypes.LOAD_DATE_AVAILABILITY_FAILURE, function () {
                        return runActionAfterDelay(actions.resetDateAvailabilityError());
                    })];
            case 3:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
